import Cookies from "js-cookie";

const CookieAgreeKey = "user_cookie_agree";

export function getCookieAgree() {
  return Cookies.get(CookieAgreeKey);
}

export function setCookieAgree(answer) {
  return Cookies.set(CookieAgreeKey, answer, { secure: true });
}

export function removeCookieAgree() {
  return Cookies.remove(CookieAgreeKey);
}